export default __webpack_public_path__ + "static/media/WEB12500GLM500x900new.091beabe.jpg";